import { render, staticRenderFns } from "./CourseV2ListenerProgress.vue?vue&type=template&id=5f06460d&"
import script from "./CourseV2ListenerProgress.vue?vue&type=script&lang=ts&"
export * from "./CourseV2ListenerProgress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports